import "./style.less";
export default function basketHeader() {
    return {
        restrict: "E",
        scope: {},
        template: require("./template.html"),

        controller: function ($scope, $rootScope, BasketStorage) {
            // Future updates
            var bookingAddedEventListener = $rootScope.$on(
                "booking-added-to-basket",
                function () {
                    $scope.updateInfo();
                }
            );

            $scope.$on("destroy", bookingAddedEventListener);

            $scope.updateInfo = function () {
                $scope.location = BasketStorage.getBookingLocation();
                $scope.activity = BasketStorage.getBookingActivity();
            };

            // on directive init
            $scope.updateInfo();
        },
    };
}
